import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import {
  formatCancellationFeeLabel,
  getCancellationFeeEuros,
} from '../appointmentTiming';

const ActionButtons = ({
  onReschedule,
  onCancelService,
  canCancel = false,
  canReschedule = false,
  scheduledDate = null,
  scheduledTimeStart = null,
}) => {
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  if (!canReschedule && !canCancel) {
    return null;
  }

  const cancellationFee = getCancellationFeeEuros(scheduledDate, scheduledTimeStart);
  const feeLabel = formatCancellationFeeLabel(cancellationFee);

  const handleCancelClick = () => {
    setShowCancelConfirm(true);
  };

  const handleConfirmCancel = () => {
    onCancelService?.();
    setShowCancelConfirm(false);
  };

  const handleCancelDismiss = () => {
    setShowCancelConfirm(false);
  };

  return (
    <>
      <div className="flex flex-col sm:flex-row gap-3">
        {canReschedule && (
          <Button
            variant="outline"
            fullWidth
            iconName="Calendar"
            iconPosition="left"
            onClick={onReschedule}
          >
            Reprogrammer l&apos;intervention
          </Button>
        )}

        {canCancel && (
          <Button
            variant="ghost"
            fullWidth
            iconName="XCircle"
            iconPosition="left"
            onClick={handleCancelClick}
            className="text-error hover:bg-error/10 border border-border"
            disabled={showCancelConfirm}
          >
            Annuler l&apos;intervention
          </Button>
        )}
      </div>

      {showCancelConfirm && canCancel && (
        <div className="fixed inset-0 z-[1100] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm animate-fade-in">
          <div className="bg-card rounded-lg shadow-lg border border-border max-w-md w-full p-6 animate-scale-in">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center flex-shrink-0">
                <Button
                  variant="ghost"
                  size="icon"
                  iconName="AlertTriangle"
                  className="text-error"
                />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  Confirmer l&apos;annulation
                </h3>
                <p className="text-sm text-muted-foreground">
                  Êtes-vous sûr de vouloir annuler cette intervention ?
                  <br />
                  Cette action est <strong className="font-bold text-foreground">irréversible</strong>.
                  <br />
                  Conformément à nos Conditions Générales de Vente (CGV), des
                  frais d&apos;annulation d&apos;un montant de{' '}
                  <span className="font-semibold text-foreground">{feeLabel}</span> seront
                  appliqués.
                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <Button variant="outline" fullWidth onClick={handleCancelDismiss}>
                Fermer
              </Button>
              <Button variant="destructive" fullWidth onClick={handleConfirmCancel}>
                Confirmer l&apos;annulation
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ActionButtons;
